export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 bg-background-100 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading text-foreground-950">联系投稿</h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              想推荐你喜欢的动漫？有资源想分享？或者有任何建议和问题，欢迎随时联系我们。51动漫网期待与每一位动漫爱好者交流互动，共同打造更好的动漫社区。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
                <span>contact@51dmw.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-wechat-line text-primary-500 text-lg"></i>
                <span>51动漫网官方</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-send-plane-2-line text-3xl md:text-4xl text-primary-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}